import React from "react";

import { makeIcon } from "./components/IconBase";
import { makeSvgIcon } from "./components/SvgIcon";

// CRM-style icon set replacing MUI icons-material.
// - Most icons render an icomoon glyph via <i className="icon-ic-*"> (font wired
//   globally in src/index.tsx). Size = font-size, color = color.
// - A few glyphs icomoon lacks (nav icons) are hand-authored inline SVGs.
// Every export is a forwardRef component (some icons anchor a <Popover> via ref)
// and accepts the MUI icon props actually used here: fontSize, color, className.

// ---- icomoon-mapped icons ----
export const MoreVert = makeIcon("icon-ic-more");
export const Edit = makeIcon("icon-ic-edit-2");
export const Delete = makeIcon("icon-ic-delete");
export const Visibility = makeIcon("icon-ic-eye-open");
export const Layers = makeIcon("icon-ic-copy");
export const Clear = makeIcon("icon-ic-close");
export const ClearRounded = makeIcon("icon-ic-close");
export const Close = makeIcon("icon-ic-close");
export const Refresh = makeIcon("icon-ic-refresh");
export const HelpOutline = makeIcon("icon-ic-info");
export const Info = makeIcon("icon-ic-info");
export const Done = makeIcon("icon-ic-done");
// The plain tick. `icon-ic-done` is the set's "closed/finished" mark and draws a cross, which
// reads as the opposite of itself next to an Enable label. (`icon-ic-chek` is the font's spelling.)
export const Check = makeIcon("icon-ic-chek");
// The cross that carries weight in a menu row. `icon-ic-close` is the close-button X and is drawn
// at about half the width of the other glyphs in the same em box, so beside an eye it reads as a
// mistake rather than an action.
export const Cancelled = makeIcon("icon-ic-cancelled");
export const Remove = makeIcon("icon-ic-minus");
export const InsertInvitation = makeIcon("icon-ic-data");
export const DateRange = makeIcon("icon-ic-data");
export const Add = makeIcon("icon-ic-plus");
export const Person = makeIcon("icon-ic-user");
export const Face = makeIcon("icon-ic-user");
export const ExitToApp = makeIcon("icon-ic-logout");
export const Menu = makeIcon("icon-ic-menu");
export const ShowChart = makeIcon("icon-ic-trending-up");
export const BarChart = makeIcon("icon-ic-reports");
export const OpenInNew = makeIcon("icon-ic-export");
export const Search = makeIcon("icon-ic-zoom");
export const SearchOutlined = makeIcon("icon-ic-zoom");
export const Fingerprint = makeIcon("icon-ic-lock");
export const Brightness4 = makeIcon("icon-ic-moon");
export const Brightness7 = makeIcon("icon-ic-sun");
export const Settings = makeIcon("icon-ic-settings");
export const Dashboard = makeIcon("icon-ic-dashbord");
export const Accessibility = makeIcon("icon-ic-users");

// ---- SVG gap icons (no icomoon equivalent; AST-specific nav) ----
export const RssFeed = makeSvgIcon(
  <path d="M6.18 15.64a2.18 2.18 0 0 1 2.18 2.18C8.36 19 7.38 20 6.18 20 5 20 4 19 4 17.82a2.18 2.18 0 0 1 2.18-2.18M4 4.44A15.56 15.56 0 0 1 19.56 20h-2.83A12.73 12.73 0 0 0 4 7.27V4.44m0 5.66a9.9 9.9 0 0 1 9.9 9.9h-2.83A7.07 7.07 0 0 0 4 12.93V10.1z" />
);

export const Category = makeSvgIcon(
  <>
    <path d="M12 2l-5.5 9h11L12 2z" />
    <circle cx="17.5" cy="17.5" r="4.5" />
    <rect x="3" y="13" width="8" height="8" rx="1" />
  </>
);

export const Store = makeSvgIcon(
  <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z" />
);

export const CurrencyExchange = makeSvgIcon(
  <path d="M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
);

export { makeIcon } from "./components/IconBase";
export { makeSvgIcon } from "./components/SvgIcon";
export type {
  IconSize,
  IconColor,
  IconProps,
  IconComponent,
  SvgIconProps,
  SvgIconComponent,
} from "./types";
